import React, { useEffect, useState } from "react";

export default function PayrollProcessingModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  assignments,
}) {
  const emptyForm = {
    employeeId: "",
    employeeName: "",
    salaryStructure: "",
    grossSalary: "",
    deductions: "",
    netSalary: "",
    month: "July",
    year: "2026",
    status: "Pending",
    remarks: "",
  };

  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm(emptyForm);
    }
  }, [initialData]);

  useEffect(() => {
    const gross = Number(form.grossSalary) || 0;
    const deduction = Number(form.deductions) || 0;

    setForm((prev) => ({
      ...prev,
      netSalary: gross - deduction,
    }));
  }, [form.grossSalary, form.deductions]);

  const handleEmployeeChange = (e) => {
    const employee = assignments.find(
      (emp) => emp.employeeId === e.target.value
    );

    if (!employee) return;

    setForm((prev) => ({
      ...prev,
      employeeId: employee.employeeId,
      employeeName: employee.employeeName,
      salaryStructure: employee.salaryStructure,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.employeeId) {
      alert("Select Employee");
      return;
    }

    if (!form.grossSalary) {
      alert("Enter Gross Salary");
      return;
    }

    onSave(form);
  };

  if (!isOpen) return null;

  return (
    <div className="finance-modal-overlay">
      <div className="finance-modal">

        <div className="finance-modal-header">
          <h2>
            {initialData ? "Edit Payroll" : "Generate Payroll"}
          </h2>
        </div>

        <form
          className="finance-modal-body"
          onSubmit={handleSubmit}
        >

          <div className="form-group">
            <label>Employee</label>

            <select
              className="finance-select"
              value={form.employeeId}
              onChange={handleEmployeeChange}
            >
              <option value="">Select Employee</option>

              {assignments.map((emp) => (
                <option
                  key={emp.employeeId}
                  value={emp.employeeId}
                >
                  {emp.employeeName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Gross Salary</label>

              <input
                className="finance-input"
                type="number"
                value={form.grossSalary}
                onChange={(e) =>
                  setForm({
                    ...form,
                    grossSalary: e.target.value,
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>Deductions</label>

              <input
                className="finance-input"
                type="number"
                value={form.deductions}
                onChange={(e) =>
                  setForm({
                    ...form,
                    deductions: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="form-group">
            <label>Net Salary</label>

            <input
              className="finance-input"
              value={form.netSalary}
              readOnly
            />
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Month</label>

              <input
                className="finance-input"
                value={form.month}
                onChange={(e) =>
                  setForm({
                    ...form,
                    month: e.target.value,
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>Year</label>

              <input
                className="finance-input"
                value={form.year}
                onChange={(e) =>
                  setForm({
                    ...form,
                    year: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="form-group">
            <label>Status</label>

            <select
              className="finance-select"
              value={form.status}
              onChange={(e) =>
                setForm({
                  ...form,
                  status: e.target.value,
                })
              }
            >
              <option>Pending</option>
              <option>Processed</option>
              <option>Draft</option>
            </select>
          </div>

          <div className="form-group">
            <label>Remarks</label>

            <textarea
              className="finance-input"
              rows="3"
              value={form.remarks}
              onChange={(e) =>
                setForm({
                  ...form,
                  remarks: e.target.value,
                })
              }
            />
          </div>

          <div className="finance-modal-footer">
            <button
              type="button"
              className="finance-secondary-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="finance-primary-btn"
            >
              {initialData
                ? "Update Payroll"
                : "Generate Payroll"}
            </button>
          </div>

        </form>

      </div>
    </div>
  );
}